define('BookingEngine/app-BookingEngine/settings',[],function () {
    return {
        container: "#filterModule",
        disabledModule: "#depModuleDisabled",
        summaryModule: "#depModuleSummary",
        activeModule: "#depModuleActive"
    };
});
